import { render } from "./PatientVisitPrint.vue?vue&type=template&id=6037126a&scoped=true"
import script from "./PatientVisitPrint.vue?vue&type=script&lang=js"
export * from "./PatientVisitPrint.vue?vue&type=script&lang=js"

import "./PatientVisitPrint.vue?vue&type=style&index=0&id=6037126a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6037126a"]])

export default __exports__